<template>
  
    <b-modal
        :title="$t('history.modal.header.AddPriceLines')"
        ref="addPriceLines-modal"
        @ok="savePriceLines"
        @cancel="reset"
        @hide="reset"
        @show="getPriceLinesAndAccount"
        :no-close-on-backdrop="true"
    >
      <b-overlay :show="show" rounded="sm">
        <form ref="form">
            <b-form-group :label="$t('history.modal.body.Company')">
                <vSelect
                    :dynamicWidth="false"
                    label="name"
                    :clearable="false"
                    :options="getCompanies"
                    v-model="selectedCompany"
                    @input="setCompany"
                    :reduce="(company) => company.id"
                    :placeholder="$t('createShipment.placeholder.Choose Company')"
                    name="companyDropdown"
                />
            </b-form-group>

            <div v-if="accounts.length > 0">
                <b-form-group :label="$t('history.modal.body.Account')">
                    <vSelect
                        :dynamicWidth="false"
                        :clearable="false"
                        :options="accounts"
                        :reduce="(account) => account.id"
                        @input="setAccount"
                        v-model="selectedAccount"
                        label="displayName"
                        :placeholder="$t('createShipment.placeholder.Select Account')"
                    />
                </b-form-group>
            </div>

            <div v-for="(item, index) in priceLines" v-bind:key="index">
                <b-form-group
                    v-if="selectedAccount !== ''"
                    :label="$t('history.modal.body.PriceLines')"
                >
                    <b-row>
                        <b-col>
                            <b-form-input
                                size="sm"
                                required
                                type="number"
                                step="0.01"
                                v-model="item.ValueSale"
                                min="0"
                                :placeholder="$t('history.placeholder.DKK')"
                            ></b-form-input>
                        </b-col>
                        <b-col>
                            <vSelect
                                :dynamicWidth="false"
                                :clearable="false"
                                :options="priceLineTypes"
                                :reduce="(priceLine) => priceLine.id"
                                label="name"
                                v-model="item.PriceLinesTypeID"
                                :placeholder="$t('createShipment.placeholder.Select Fee Type')"
                            />
                        </b-col>

                        <b-input-group-append
                            class="addPriceLineIcon"
                            v-if="index === 0"
                        >
                            <font-awesome-icon
                                @click="addPriceLine"
                                icon="plus-circle"
                                size="lg"
                            />
                        </b-input-group-append>

                        <b-input-group-append
                            v-if="index > 0"
                            class="addPriceLineIcon"
                        >
                            <font-awesome-icon
                                @click="removePriceLine(index)"
                                icon="minus-circle"
                                size="lg"
                            />
                        </b-input-group-append>
                    </b-row>
                </b-form-group>
            </div>
        </form>

        <template v-slot:modal-footer="{ ok, cancel }">
            <b-button @click="cancel()">Cancel</b-button>
            <b-button
                @click="ok()"
                name="addPriceLinesModalButton"
                :disabled="disableButton"
                variant="primary"
            >{{ $t('history.modal.button.AddPriceLines') }}</b-button>
        </template>
      </b-overlay>
    </b-modal>
</template>
<script>
  import { CORE_PREFIX, ACTIONS, MUTATIONS, HISTORY_PREFIX } from '@/store/constants';
  import helpers from '@/helper';
  import vSelect from '../../vSelect';
  import { mapGetters } from 'vuex';

  export default {
      props: {
          shipmentId: { type: Number, required: true },
          linkId: {type: String}
      },

      components: {
          vSelect,
      },

      computed: {
          disableButton() {
              return this.priceLines.some((x) => x.PriceLinesTypeID == '');
          },
          ...mapGetters('core', ['getCompanies'])
      },
      data() {
          return {
              accounts: [],
              priceLineTypes: [],
              priceLines: [{ ValueSale: '', PriceLinesTypeID: '' }],
              selectedCompany: '',
              selectedAccount: '',
              show: false
          };
      },

    methods: {
          async getCompanyAccounts(companyId) {
            this.accounts = [];

            const response = await this.$store.dispatch(
                HISTORY_PREFIX + ACTIONS.HISTORY.FETCH_COMPANY_ACCOUNTS,
                companyId
            );
          
            this.accounts = response.data;
          },

          async getPriceLineTypes() {
              const response = await this.$store.dispatch(
                  HISTORY_PREFIX + ACTIONS.HISTORY.FETCH_PRICE_LINE_TYPES
              );

              this.priceLineTypes = response.data;
          },
      
          async getPriceLinesAndAccount(){
            this.show = true
            let payload = {
              shipmentId: this.shipmentId,
              linkId: this.linkId
            }
            const response = await this.$store.dispatch(
                HISTORY_PREFIX + ACTIONS.HISTORY.FETCH_PRICE_LINES, payload
            );
            
            if(response !== undefined){
              await this.setPriceLinesAndAccounts(response)
            }
          },
      
          async setPriceLinesAndAccounts(response){
            this.priceLines = []
            response.priceLines.forEach(pl => this.priceLines.push({PriceLinesTypeID: pl.priceLinesTypeID, ValueSale: pl.valueSale}))

            if(response.account !== undefined){
              await this.setCompany(response.account)

              if(response.companyAccount !== undefined){
                await this.getPriceLineTypes();
                let acc = this.accounts.find(x => x.id === response.companyAccount)
                this.selectedAccount = acc.id;
              }
            }
            if(this.priceLines.length === 0) this.priceLines = [{ ValueSale: '', PriceLinesTypeID: '' }];
            this.show = false;
          },

          async setCompany(value) {
              await this.getCompanyAccounts(value);

              if (this.selectedAccount) {
                  this.selectedAccount = '';
              } else {
                let co = this.getCompanies.find(x => x.id === value)
                this.selectedCompany = co.id;
              }
          },

          setAccount(value) {
              if(this.priceLineTypes === []){
                this.getPriceLineTypes();
              }
          },

          showAddPriceLinesModal() {
              this.$refs['addPriceLines-modal'].show();
          },

          addPriceLine() {
              this.priceLines.push({ ValueSale: '', PriceLinesTypeID: '' });
          },

          removePriceLine(index) {
              this.priceLines.splice(index, 1);
          },

          savePriceLines() {
              const request = {
                  CompanyId: this.selectedCompany,
                  AccountId: this.selectedAccount,
                  PriceLines: this.priceLines,
                  ShipmentId: this.shipmentId,
              };

              this.$store.dispatch(HISTORY_PREFIX + ACTIONS.HISTORY.ADD_PRICE_LINES, request);
          },

          reset() {
              this.selectedCompany = '';
              this.selectedAccount = '';
              this.accounts = [];
              this.priceLines = [{ ValueSale: '', PriceLinesTypeID: '' }];
          }
      },
  };
</script>

<style>
  .addPriceLineIcon {
      margin-right: 15px;
  }
</style>
